import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Artist } from "types/artist";
import { useParams } from "react-router";

export interface PlatformLinks {
  social_platform_id: string;
  url: string;
}

export const useArtists = (
  status: string = '',
  currentPage: number = 0,
  pageCount: number = 10,
  search:string = ''
) => {
  const [artists, setArtists] = React.useState<Artist[]>([]);
  const [artist, setArtist] = React.useState({});
  const [fetching, setFetching] = React.useState(true);
  const [creating, setCreating] = React.useState(false);
  const [total, setTotal] = React.useState(0);
  const { id } = useParams()


  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => await getArtists(status, currentPage, pageCount, search))();
  }, []);
  useEffect(() => {
    (async () => await getArtists(
      status,
      currentPage,
      pageCount,
      search
    ))();
  }, [status, currentPage, pageCount,search]);



  const getArtists = async (
    status: string = '',
    currentPage: number = 0,
    pageCount: number = 10,
    search: string = ''
  ) => {
    try {
      setFetching(true);

      const queryParams = new URLSearchParams({
        status,
        page: (currentPage ).toString(),
        per_page: pageCount.toString(),
        name: search
      });

      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.Artists}?${queryParams.toString()}`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTotal(response.data.meta.total);
      setArtists(response.data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  const getArtist = async (id: string) => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.Artists}/${id}`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setArtist(response.data.data);
    } catch (error) {
      console.error('Failed to fetch artist:', error);
    } finally {
      setFetching(false);

    }
  };


  const createArtist = async (name: string, links: PlatformLinks[], status: boolean = false,) => {
    try {
      setCreating(true);


      const result = await axios.post(
        `${API_BASE_URL}${API_URLS.Artists}`,
        { name, platform_links: links, status,  },
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await getArtists();

      return {
        ...result.data.data,
      };
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      setCreating(false);
    }
  };


  const removeArtist = async (id: string) => {
    try {
      setCreating(true);
      await axios.delete(
        `${API_BASE_URL}${API_URLS.Artists}/${id}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      await getArtists();
    }  catch (e: any) {
      let errorMessage = 'Something went wrong';

      if (e.response?.data?.message) {
        errorMessage = e.response.data.message;
      } else if (e.response?.data?.errors) {
        const errors = e.response.data.errors;
        const allErrors = Object.values(errors)
          .flat()
          .map((err: any) => err.message || JSON.stringify(err))
          .join('\n');
        errorMessage = allErrors;
      } else if (e.message) {
        errorMessage = e.message;
      }

      throw new Error(errorMessage);
    } finally {
      setCreating(false);
    }
  };


  interface UpdateArtistData {
    cover?: File;
    [key: string]: any;
  }

  const upDateArtist = async (id: string, data: UpdateArtistData = {}) => {
    try {
      setCreating(true);
      setFetching(true);

      const formData = new FormData();

      if (data?.cover) {
        formData.append('cover', data.cover);
      }
        Object.entries(data).forEach(([key, value]) => {
        if (key !== 'cover') {
          formData.append(key, value);
        }
      });

      const result = await axios.post(
        `${API_BASE_URL}${API_URLS.Artists}/${id}`,
        formData,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      await getArtists();
      await getArtist(id);
    } catch (e) {
      console.error(e);
    } finally {
      setCreating(false);
      setFetching(false);
    }
  };



  return { artists, creating, fetching, createArtist, removeArtist, total, upDateArtist, getArtist, artist };
};
